import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes
} from '@angular/animations';

export const fadeInOutAnimation =
    trigger('EnterFadeIn-LeaveFadeOut', [
        // Enter transition
      transition(':enter', [
          // styles at start of transition
        style({ opacity: 0 }),
        // animation and styles at end of transition
        animate('0.5s 0.2s', keyframes([
          style({ opacity: 0 }),
          style({ opacity: 1 })
        ]))
      ]),
      transition(':leave', [
          // styles at start of transition
        style({ opacity: 1 }),
        // animation and styles at end of transition
        animate('0.5s 0.2s', keyframes([
          style({ opacity: 1 }),
          style({ opacity: 0 })
        ]))
      ])
    ]);



// WEBPACK FOOTER //
// ./src/app/shared/animations/fadeInOut.animation.ts